'use client';

import { usePublicAnalytics } from '@/lib/analytics/use-public-analytics';

import Script from 'next/script';
import { usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';
import {
  COOKIE_CONSENT_CHANGED_EVENT,
  GOOGLE_ANALYTICS_READY_EVENT,
  isAnalyticsCookieConsentAccepted,
  isPostHogEnabledForPathname,
} from '@/lib/analytics/posthog-paths';

const GA_MEASUREMENT_ID = 'G-NQYFQGXRZ8';

export default function GoogleAnalytics() {
  const publicAnalytics = usePublicAnalytics();
  const pathname = usePathname();
  const [consentOk, setConsentOk] = useState(false);

  useEffect(() => {
    const read = () => setConsentOk(isAnalyticsCookieConsentAccepted());
    read();
    window.addEventListener(COOKIE_CONSENT_CHANGED_EVENT, read);
    return () =>
      window.removeEventListener(COOKIE_CONSENT_CHANGED_EVENT, read);
  }, []);

  if (!publicAnalytics || !consentOk || !isPostHogEnabledForPathname(pathname || '/')) {
    return null;
  }

  return (
    <>
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`}
        strategy="afterInteractive"
      />
      <Script id="google-analytics" strategy="afterInteractive">
        {`
                window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                gtag('js', new Date());
                gtag('consent', 'default', {
                  analytics_storage: 'granted',
                  ad_storage: 'denied',
                  ad_user_data: 'denied',
                  ad_personalization: 'denied',
                });
                gtag('config', '${GA_MEASUREMENT_ID}', { send_page_view: false });
                window.dispatchEvent(new Event('${GOOGLE_ANALYTICS_READY_EVENT}'));
              `}
      </Script>
    </>
  );
}
